











import { Component, Vue } from "vue-property-decorator";
import viewBox from "@/components/viewBox.vue";
@Component({
  components: { viewBox }
})
export default class Rule extends Vue {
  itemList: string[] = [
    "网友选择湿地公园、植物后，可成为“领养者”;",
    "网友参与答题，答对可领取浇灌植物的水滴（1道题=1水滴）;",
    "共20道题目，每次5道题（4道单选题+1道多选题），题目随机；",
    "每天4次答题机会，每次答题限时3分钟；",
    "活动时间：2022年6月1日9时至6月2日22时；",
    "活动时间内，前1000名率先让植物完全开花（需20水滴）的“领养者”，可领取湿地植物“盲盒”；",
    "排行榜2022年6月3日10时公布；",
    "前1000名网友完整如实填写收货信息后，将收到湿地水培植物一份；",
    "收货信息填写截止时间：2022年6月5日22时；未按时提交地址，视为放弃领奖。",
    "植物“盲盒”将于6月11日前陆续寄出。"
  ];
  mounted() {
    document.title = "活动规则";
  }
  getImg(index: number) {
    return require(`../assets/images/rule/${index}.png`);
  }
}
